import { render, staticRenderFns } from "./AllRestorationSubmissions.vue?vue&type=template&id=54918b12&scoped=true&"
import script from "./AllRestorationSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllRestorationSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllRestorationSubmissions.vue?vue&type=style&index=0&id=54918b12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54918b12",
  null
  
)

export default component.exports